var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SalesRepDataActionType } from "../actions/actionTypes";
import { upsertSTReportsOrdersCache } from "../stReportsOrdersCache";
var initialState = {
    baseData: {},
    ordersData: {},
    viewCouponData: [],
    customerNewUpdatedData: {},
    productsData: [],
    loggedInRepDetails: window.salesteam_bo_props,
    draftOrderData: [],
    stReportsData: null,
    stReportsDefaultData: null,
    stReportsOrdersByDateRange: {},
    wholesalePriceData: {},
    editDraftOrder: {},
    activeTab: {},
    createOrderTab: {},
    checkoutConfirmationPopUp: {},
    customerDetailsCreateInvoice: {},
    locationPricelistData: {},
    productTableData: {
        selectedProductData: [],
        isQuantityError: {},
        isDiscountError: {},
        discountKeyValueObject: {},
        selectedDiscountType: "",
        isDiscoutAppliedInEditDraft: false,
    },
    cartShareProductData: [],
    collectionProductsData: [],
    customerListWithMainContact: [],
    catalogProductList: [],
    repAllCustomers: {
        customers: [],
        endCursor: "",
        hasPrevious: false,
        hasNext: false,
    },
    b2bCompaniesData: {
        companies: [],
        endCursor: "",
        startCursor: "",
        hasNext: false,
        hasPrevious: false,
        searchQuery: "",
    },
    territoryReportData: null,
};
var salesRepDataReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SalesRepDataActionType.BASE_DATA:
            return __assign(__assign({}, state), { baseData: action.payload });
        case SalesRepDataActionType.ORDERS_DATA:
            return __assign(__assign({}, state), { ordersData: action.payload });
        case SalesRepDataActionType.CUSTOMER_ADDRESS_DATA:
            return __assign(__assign({}, state), { customerNewUpdatedData: action.payload });
        case SalesRepDataActionType.PRODUCTS_DATA:
            return __assign(__assign({}, state), { productsData: action.payload });
        case SalesRepDataActionType.VIEW_COUPON_DATA:
            return __assign(__assign({}, state), { viewCouponData: action.payload });
        case SalesRepDataActionType.DRAFT_ORDER_DATA:
            return __assign(__assign({}, state), { draftOrderData: action.payload });
        case SalesRepDataActionType.ST_REPORTS_DATA:
            return __assign(__assign({}, state), { stReportsData: action.payload });
        case SalesRepDataActionType.ST_REPORTS_DEFAULT_DATA:
            return __assign(__assign({}, state), { stReportsDefaultData: action.payload });
        case SalesRepDataActionType.ST_REPORTS_CLEAR_ORDERS_CACHE:
            return __assign(__assign({}, state), { stReportsOrdersByDateRange: {} });
        case SalesRepDataActionType.ST_REPORTS_ORDERS_CACHE: {
            var _b = action.payload, rangeKey = _b.rangeKey, tab = _b.tab, pageNumber = _b.pageNumber, pageSize = _b.pageSize, searchQuery = _b.searchQuery, apiPayload = _b.apiPayload;
            return __assign(__assign({}, state), { stReportsOrdersByDateRange: upsertSTReportsOrdersCache((_a = state.stReportsOrdersByDateRange) !== null && _a !== void 0 ? _a : {}, rangeKey, tab, pageNumber, pageSize, searchQuery, apiPayload) });
        }
        case SalesRepDataActionType.UPDATE_SINGLE_SALES_REP:
            return __assign(__assign({}, state), { baseData: __assign(__assign({}, state.baseData), { SingleSalesRep: action.payload }) });
        case SalesRepDataActionType.UPDATE_REP_PROFILE:
            return __assign(__assign({}, state), { baseData: __assign(__assign({}, state.baseData), { SingleSalesRep: __assign(__assign({}, state.baseData.SingleSalesRep), { ProfileImagePath: action.payload }) }) });
        case SalesRepDataActionType.WHOLESALE_PRICE_DATA:
            return __assign(__assign({}, state), { wholesalePriceData: action.payload });
        case SalesRepDataActionType.RESET_INITIAL_STATE:
            return __assign({}, initialState);
        case SalesRepDataActionType.EDIT_DRAFT_ORDER:
            return __assign(__assign({}, state), { editDraftOrder: action.payload });
        case SalesRepDataActionType.ACTIVE_TAB:
            return __assign(__assign({}, state), { activeTab: action.payload });
        case SalesRepDataActionType.CREATE_ORDER_TAB:
            return __assign(__assign({}, state), { createOrderTab: action.payload });
        case SalesRepDataActionType.CHECKOUT_CONFIRMATION_POPUP:
            return __assign(__assign({}, state), { checkoutConfirmationPopUp: action.payload });
        case SalesRepDataActionType.CUSTOMER_DETAILS_CREATE_INVOICE:
            return __assign(__assign({}, state), { customerDetailsCreateInvoice: action.payload });
        case SalesRepDataActionType.LOCATION_PRICELIST_DATA:
            return __assign(__assign({}, state), { locationPricelistData: action.payload });
        case SalesRepDataActionType.PRODUCT_TABLE_DATA:
            return __assign(__assign({}, state), { productTableData: action.payload });
        case SalesRepDataActionType.CART_SHARE_PRODUCT_DATA:
            return __assign(__assign({}, state), { cartShareProductData: action.payload });
        case SalesRepDataActionType.COLLECTION_PRODUCTS_DATA:
            return __assign(__assign({}, state), { collectionProductsData: action.payload });
        case SalesRepDataActionType.CUSTOMER_LIST_WITH_MAINCONTACT:
            return __assign(__assign({}, state), { customerListWithMainContact: action.payload });
        case SalesRepDataActionType.CATALOG_PRODUCT_LIST:
            return __assign(__assign({}, state), { catalogProductList: action.payload });
        case SalesRepDataActionType.REP_ALL_CUSTOMERS:
            return __assign(__assign({}, state), { repAllCustomers: action.payload });
        case SalesRepDataActionType.B2B_COMPANIES_DATA:
            return __assign(__assign({}, state), { b2bCompaniesData: action.payload });
        case SalesRepDataActionType.TERRITORY_REPORT_DATA:
            return __assign(__assign({}, state), { territoryReportData: action.payload });
    }
    return state;
};
export default salesRepDataReducer;
